import {
  FileCheck, Zap, Wrench, Lightbulb, Gauge, PlugZap,
  Activity, ShieldCheck, Building2, PaintRoller
} from "lucide-react";

export const CONTACT = {
  phone: "(11) 99473-8067",
  phoneRaw: "5511994738067",
  email: "totalengenhariaeservicos@gmail.com",
  instagram: "totalengenhariaeservicos",
  instagramUrl: "https://instagram.com/totalengenhariaeservicos",
};

export const WHATSAPP_MSG =
  "Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20visita%20t%C3%A9cnica%20com%20a%20Total%20Engenharia.";

export const AREAS = [
  "Praia Grande", "Santos", "São Vicente", "Guarujá", "Cubatão", "Baixada Santista",
];

export const COMPLIANCE = ["CREA-SP", "ART", "NR-10", "NR-35", "NBR 5410"];

export const MANIFESTO = [
  {
    n: "01",
    title: "Segurança",
    text: "Segurança técnica e jurídica em cada intervenção. Protegemos pessoas, patrimônio e a tranquilidade do condomínio com responsabilidade técnica registrada.",
  },
  {
    n: "02",
    title: "Eficiência",
    text: "Economia inteligente através de retrofit, iluminação LED e inspeções preventivas que reduzem custos operacionais e evitam falhas antes que aconteçam.",
  },
  {
    n: "03",
    title: "Confiança",
    text: "Transparência total com relatórios fotográficos de antes e depois, orçamentos claros e uma parceria ética construída ao lado de síndicos e administradoras.",
  },
];

export const SERVICES = [
  { icon: FileCheck, title: "Laudos Técnicos", desc: "Laudos das instalações elétricas conforme NBR 5410, SPDA e demais sistemas, com emissão de ART.", tag: "NBR 5410" },
  { icon: ShieldCheck, title: "SPDA / Para-Raios", desc: "Inspeção visual, medição ôhmica e laudo completo do sistema de proteção contra descargas atmosféricas.", tag: "Proteção" },
  { icon: Wrench, title: "Manutenção Elétrica", desc: "Manutenção preventiva e corretiva das instalações elétricas das áreas comuns do condomínio.", tag: "Preventiva" },
  { icon: Lightbulb, title: "Eficiência Energética", desc: "Retrofit e iluminação LED com sensores de presença para economia e mais conforto.", tag: "Economia" },
  { icon: Gauge, title: "Quadros de Comando", desc: "Montagem, manutenção e modernização de quadros de comando para bombas, recalque e pressurização.", tag: "Bombas" },
  { icon: PlugZap, title: "Veículos Elétricos", desc: "Estudos, projetos e instalação segura de infraestrutura para carregadores nas garagens.", tag: "EV Ready" },
  { icon: Zap, title: "Centro de Medição", desc: "Adequações, manutenção e modernização de centros de medição de energia.", tag: "Modernização" },
  { icon: Activity, title: "Inspeções por Termografia", desc: "Termografia elétrica para identificar pontos de aquecimento e antecipar riscos.", tag: "Diagnóstico" },
  { icon: Building2, title: "Manutenção Predial", desc: "Manutenção em fachadas, telhados, estruturas e áreas comuns do condomínio.", tag: "Predial" },
  { icon: PaintRoller, title: "Pintura & Conservação", desc: "Serviços de pintura e conservação para valorização e preservação do patrimônio.", tag: "Estética" },
];

export const PROCESS = [
  { n: "01", title: "Contato", text: "Você nos apresenta a necessidade do condomínio." },
  { n: "02", title: "Visita Técnica", text: "Avaliação presencial das instalações no local." },
  { n: "03", title: "Diagnóstico", text: "Análise técnica de riscos e oportunidades." },
  { n: "04", title: "Relatório & Orçamento", text: "Proposta clara com recomendações e valores." },
  { n: "05", title: "Execução com ART", text: "Serviço por equipe própria, com garantia e ART." },
  { n: "06", title: "Entrega & Pós-Serviço", text: "Relatório final, fotos antes/depois e suporte contínuo." },
];

export const GALLERY = [
  { url: "https://images.unsplash.com/photo-1652715564391-38cc4475b7f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBlbGVjdHJpY2FsJTIwcGFuZWwlMjBhYnN0cmFjdHxlbnwwfHx8fDE3ODQ1ODc5OTJ8MA&ixlib=rb-4.1.0&q=85", title: "Modernização de Quadro Elétrico", cat: "Elétrica" },
  { url: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMHNhZmV0eSUyMGdlYXIlMjB3b3JraW5nfGVufDB8fHx8MTc4NDU4Nzk5Mnww&ixlib=rb-4.1.0&q=85", title: "Execução em Campo", cat: "Manutenção" },
  { url: "https://images.pexels.com/photos/8961133/pexels-photo-8961133.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", title: "Diagnóstico & Projeto", cat: "Engenharia" },
  { url: "https://images.unsplash.com/photo-1576446470246-499c738d1c8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBlbGVjdHJpY2FsJTIwcGFuZWwlMjBhYnN0cmFjdHxlbnwwfHx8fDE3ODQ1ODc5OTJ8MA&ixlib=rb-4.1.0&q=85", title: "Adequação de Disjuntores", cat: "Compliance" },
];

export const HERO_IMG = "https://images.unsplash.com/photo-1778071118627-877aecba1b0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjByZXNpZGVudGlhbCUyMGJ1aWxkaW5nJTIwbmlnaHR8ZW58MHx8fHwxNzg0NTg3OTkxfDA&ixlib=rb-4.1.0&q=85";
